import {
  ContentfulQueryKeys,
  PageCorporateFullWidthFilter,
  useContentfulQuery,
} from '@oresundsbron/api';
import { useRouter } from 'next/router';

export function usePageCorporateFullWidthContent(
  filter: PageCorporateFullWidthFilter
) {
  const { locale, isPreview } = useRouter();

  let { data, error, isLoading } = useContentfulQuery(
    ContentfulQueryKeys.PageCorporateFullWidthContent({
      ...filter,
      locale,
      preview: isPreview,
    }),
    (q) =>
      q.PageCorporateFullWidth.getContent({
        ...filter,
        locale,
        preview: isPreview,
      }),
    { staleTime: Infinity, enabled: !!filter.id }
  );
  return { data, error, isLoading };
}
